module.exports = __webpack_public_path__ + "img/floor1_2.438a669c.jpg";